import ResponsiveImage from "../../atoms/image/ResponsiveImage";

export default function DoubleCTA({
  data,
  className,
  leftBoxClasses = "",
  rightBoxClasses = "",
}) {
  const Description = ({ data }) => {
    return data.map((item, count) => {
      return (
        <p
          className="lg:mt-3"
          dangerouslySetInnerHTML={{ __html: item }}
          key={count}
        />
      );
    });
  };
  const Cards = ({ item: cardsData }) => {
    return cardsData.map((card, count) => {
      const appMode = process.env.APP_MODE;
      const link = card?.cta?.href?.[appMode] || card?.cta?.href;
      if (card.hasOwnProperty("image")) {
        return (
          <figure
            key={count}
            className={` md:w-100 bg-${card.boxcolor} has-after ${
              count == 1 ? rightBoxClasses : leftBoxClasses
            }`}
          >
            <ResponsiveImage
              width={card.image.dimensions[0]}
              height={card.image.dimensions[1]}
              imgClass="img-fit md:w-100"
              wrapClass="lg:maxw-lg"
              src={card.image.src}
              alt={card.image.alt}
              dpi={card.image.prefixes.dpi}
              mobile={card.image.prefixes.mobile}
            />
          </figure>
        );
      } else {
        const ctaAttrs = {};
        if (card.hasOwnProperty("cta")) {
          if (card.cta.hasOwnProperty("isExternal") && card.cta.isExternal) {
            ctaAttrs.target = "_blank";
            ctaAttrs.rel = "noopener noreferrer";
          }
        }
        return (
          <article
            key={count}
            className={`text-left lg:maxw-lg bg-light br-8 lg:py-10 lg:px-10 md:pt-3 md:pb-4 md:pl-2 md:pr-3 md:fx--o-2 ${
              count == 1 ? rightBoxClasses : leftBoxClasses
            } `}
          >
            <h2
              className="text-mdl lg:mb-3 md:mb-2"
              dangerouslySetInnerHTML={{ __html: card.title }}
            />
            <Description data={card.desc} />
            <a href={link} className="btn-primary md:w-100 mt-5" {...ctaAttrs}>
              <span>{card.cta.text}</span>
            </a>
          </article>
        );
      }
    });
  };
  return (
    <section
      className={`container cta-w-image lg:d-fx fx--sb md:fx md:fx--w ${className}`}
    >
      <Cards item={data} />
    </section>
  );
}
